import React, {Component} from "react"
import {connect} from "react-redux";
import {isDistributionChannelIndividual, uiFlowStandalone} from "../utils/common";
import {Route, Redirect} from "react-router-dom";

const mapStateToProps = (state) => {
    const {initialData} = state;
    return {
        isStandaloneFlow:  initialData.uiFlow === uiFlowStandalone,
        isIndividual: isDistributionChannelIndividual(initialData.distributionChannel),
    }
};

class StandaloneOnlyRoute extends Component {
    render() {
        const { isStandaloneFlow, isIndividual, allowIndividual, render: renderFunc, ...props } = this.props
        const allowed = isStandaloneFlow || (!!allowIndividual && isIndividual);
        return <Route {...props} render={(props) => {
            return allowed ? renderFunc(props) : <Redirect to={"/"}/>} }
        />
    }
}

export default connect(mapStateToProps)(StandaloneOnlyRoute);